import { Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { Title, TitleItem, TitleUpsert } from '../../_objects/title';
import { TitleSchema } from '../../_offline/models/title.schema';
import { TitleDbService } from '../database/title-db.service';
import { TitleContractService } from '../interfaces/title-contract.service';

@Injectable({
  providedIn: 'root'
})
export class TitleOfflineService implements TitleContractService {

  public constructor(private titleDbService: TitleDbService) { }

  public getTitles(): Observable<Title> {
    return this.getTitleFromDb();
  }

  public upsertTitle(titleUpsert: TitleUpsert): Observable<Title> {
    return this.titleDbService.getAll()
      .pipe(
        mergeMap(value => {
          value.items = JSON.stringify(titleUpsert.items);
          value.lastUpdateDate = new Date().toISOString();

          return this.titleDbService.putAll(value);
        }),
        mergeMap(() => this.getTitleFromDb())
      );
  }

  private parseTitleFromSchema(value: TitleSchema): Title {
    const result = new Title();
    result.id = value.id;
    result.items = JSON.parse(value.items) as Array<TitleItem>;
    result.isDeleted = value.isDeleted;
    result.isValid = value.isValid;
    result.createDate = value.createDate;
    result.lastUpdateDate = value.lastUpdateDate;
    result.schemaVersion = value.schemaVersion;
    result.createdBy = value.createdBy;
    result.lastUpdatedBy = value.lastUpdatedBy;
    return result;
  }

  private getTitleFromDb(): Observable<Title> {
    return this.titleDbService.getAll()
      .pipe(
        filter(titles => !!titles),
        map(value => this.parseTitleFromSchema(value))
      );
  }
}
